import React, { useEffect, useState } from "react";
import { Waypoint } from "react-waypoint";
import { Toast } from "utils/toast";
import { useHistory } from "react-router-dom";
import { getAllNotification, removeNotification } from "service/Notification";
import Loader from "component/common/Loader";

import styles from "./Notification.module.scss";

const NotifyComp = ({ closePopUp }) => {
  const history = useHistory();

  let [page, setPage] = useState(1);

  let [totalPages, setTotalPages] = useState();

  let [notification, setNotification] = useState([]);

  let [loading, setLoading] = useState(true);

  useEffect(() => {
    getNotification();
  }, [page]);

  const getNotification = async () => {
    try {
      let response = await getAllNotification({ page: page });
      if (response.status == 200) {
        setNotification(notification.concat(response.data.data.data));
        setTotalPages(response.data.data.pageMeta.totalPages);
        setLoading(false);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const redirect = async (slug, id, type) => {
    try {
      let response = await removeNotification(id);
      if (response.status == 200) {
        if (type == "sale") {
          history.push(`/admin/inventory/detail/${slug}`);
          closePopUp()
        } else {
          closePopUp()
          history.push(`/admin/donation/detail/${slug}`);
        }
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const fetchData = () => {
    if (page <= totalPages) {
      setPage(page + 1);
    }
  };

  const getMonth = (month) => {
    switch (month) {
      case 1:
        return "Jan";
      case 2:
        return "Feb";
      case 3:
        return "Mar";
      case 4:
        return "Apr";
      case 5:
        return "May";
      case 6:
        return "Jun";
      case 7:
        return "Jul";
      case 8:
        return "Aug";
      case 9:
        return "Sep";
      case 10:
        return "Oct";
      case 11:
        return "Nov";
      case 12:
        return "Dec";
      default:
        break;
    }
  };

  const getDate = (date) => {
    return `${new Date(date).getDate()}th ${getMonth(
      new Date(date).getMonth()
    )} ${String(new Date(date).getFullYear()).slice(2, 4)}`;
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className={styles.notify_title}>
        <b>Notification</b>
      </div>
      <div className={styles.notify_container}>
        {notification.length != 0 ? (
          notification.map((list, index) => {
            return (
              <div className={styles.notification_card} key={index}>
                <div>
                  <b>{list.message}</b>
                  <span>{getDate(list.notificationDate)}</span>
                </div>
                <div>
                  <button
                    onClick={() => redirect(list.Id, list._id, list.saleType)}
                  >
                    VIEW
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-record">
            <b>No New Notification</b>
          </div>
        )}
        {page < totalPages && (
          <Waypoint onEnter={fetchData}>
            <span className="d-block text-center">Loading...</span>
          </Waypoint>
        )}
      </div>
    </>
  );
};

export default NotifyComp;
